import React, { useState, useEffect } from 'react';

import Table from "components/Table/Table.js";
import { Modal } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';

import api from "assets/services/api";



function ModalViewSellsman(props) {
    const [sellsman, setSellsman] = useState([]);

    useEffect(() => {
        handleShowClients()
    }, [props.props.id])

    async function handleShowClients() {
        if(props.props.id_sellsman){
            const response = await api.get('client/of/sellsman/' + props.props.id_sellsman);
            setSellsman(response.data);
        }
    }

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Vendedor de {props.props.social_reason}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {sellsman.map((sellm, index) => (
                    <Table key={String(sellm.id)}
                        index={index}
                        tableHeaderColor="primary"
                        tableHead={["Nome", "Sobrenome", "Endereço", "Contato"]}
                        tableData={[
                            [sellm.name, sellm.lastname, sellm.address, sellm.contact]]}
                    />
                ))}
            </Modal.Body>
        </Modal>
    );
}

export default ModalViewSellsman;